export class M3DinByActividad{
    public IDActividad:string;
    public Actividad:string;
    public IDDinamica:string;
    public TipoDinamica:string;
    public Nombre:string;
    public Requerido:boolean;

    //Solo Presentacion
    public Valor:string;

}